var InfiniteCollectionScroll = (function () {
  var SELECTORS = {
    sectionRoot: '#CollectionAjaxContent',
    grid: '.grid',
    pagination: '.pagination',
    nextLink: '.pagination .next a'
  };

  var state = {
    loading: false,
    observer: null,
    sentinel: null
  };

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function makeSentinel() {
    var el = document.createElement('div');
    el.id = 'infinite-scroll-sentinel';
    el.style.height = '1px';
    el.style.width = '100%';
    return el;
  }

  function makeLoader() {
    var el = document.createElement('div');
    el.id = 'infinite-scroll-loader';
    el.style.textAlign = 'center';
    el.style.padding = '18px';
    el.style.fontSize = '14px';
    el.style.opacity = '0.7';
    el.innerHTML = 'Loading more...';
    return el;
  }

  function removeLoader() {
    var loaderEl = document.getElementById('infinite-scroll-loader');
    if (loaderEl && loaderEl.parentNode) loaderEl.parentNode.removeChild(loaderEl);
  }

  function xhrGet(url, onSuccess, onError) {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', url, true);
    xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;
      if (xhr.status >= 200 && xhr.status < 300) {
        onSuccess(xhr.responseText);
      } else {
        onError(new Error('Request failed: ' + xhr.status));
      }
    };
    xhr.send();
  }

  function loadNextPage() {
    if (state.loading) return;

    var root = $(SELECTORS.sectionRoot) || document;
    var nextA = $(SELECTORS.nextLink, root);
    var grid = $(SELECTORS.grid, root);

    if (!nextA || !grid) return;

    var url = nextA.href;
    state.loading = true;

    var loader = makeLoader();
    root.appendChild(loader);

    xhrGet(
      url,
      function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var newRoot = $(SELECTORS.sectionRoot, doc) || doc;
        var newGrid = $(SELECTORS.grid, newRoot);
        var newNextA = $(SELECTORS.nextLink, newRoot);

        var currentPagination = $(SELECTORS.pagination, root);

        // Append items
        if (newGrid) {
          var items = Array.prototype.slice.call(newGrid.children);
          for (var i = 0; i < items.length; i++) {
            grid.appendChild(items[i]);
          }
        }

        // Update next link or stop
        if (currentPagination) {
          if (newNextA && newNextA.href) {
            nextA.href = newNextA.href;
          } else {
            currentPagination.parentNode.removeChild(currentPagination);
            if (state.observer && state.sentinel) state.observer.unobserve(state.sentinel);
          }
        }

        removeLoader();
        state.loading = false;
      },
      function (err) {
        console.error('Infinite scroll error:', err);
        removeLoader();
        state.loading = false;
      }
    );
  }

  function init() {
    var root = $(SELECTORS.sectionRoot) || document;
    var grid = $(SELECTORS.grid, root);
    var nextA = $(SELECTORS.nextLink, root);

    if (!grid || !nextA) return;

    state.sentinel = makeSentinel();
    grid.parentNode.appendChild(state.sentinel);

    if (!('IntersectionObserver' in window)) {
      // Fallback: load on scroll near bottom
      window.addEventListener('scroll', function () {
        if (state.loading) return;
        if ((window.innerHeight + window.pageYOffset) >= (document.body.offsetHeight - 1200)) {
          loadNextPage();
        }
      });
      return;
    }

    state.observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) loadNextPage();
      }
    }, { root: null, rootMargin: '800px 0px', threshold: 0 });

    state.observer.observe(state.sentinel);
  }

  return { init: init };
})();

document.addEventListener('DOMContentLoaded', function () {
  InfiniteCollectionScroll.init();
});